"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          id: '',
          uuid: '',
          givenName: '',
          familyName: '',
          phone: '',
          birthday: '',
          genderCode: '',
          city: '',
          state: '',
          countryCode: '',
          orgName: '',
          jobTitle: '',
          email: '',
          bio: ''
        };
      }
    }
  },
  data() {
    return {
      countryList: [],
      genderList: [],
      me: {}
    };
  },
  created() {
    // console.log('page-profile-acount-user', this.user)
    this.me = {
      id: this.user.id,
      uuid: this.user.uuid,
      givenName: this.user.givenName,
      familyName: this.user.familyName,
      phone: this.user.phone,
      birthday: this.user.birthday,
      genderCode: this.user.genderCode,
      city: this.user.city,
      state: this.user.state,
      countryCode: this.user.countryCode,
      orgName: this.user.orgName,
      jobTitle: this.user.jobTitle,
      bio: this.user.bio
    };
    this.$store.dispatch('facets/getInitData', 'en').then(() => {
      this.countryList = this.$store.getters.countries;
      this.genderList = this.$store.getters.genders;
    });
  },
  methods: {
    save() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const email = (0, _cookie.getCookie)('EMAIL');
      if (this.me.givenName === "") {
        const msg = "Given name is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.me.familyName === "") {
        const msg = "Surname is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      // console.log('token', token)
      (0, _user.updateMyProfile)(token, this.me).then(response => {
        const data = response.data;
        // console.log('page-profile-save', response)
        this.me.givenName = data.givenName;
        this.me.familyName = data.familyName;
        this.me.phone = data.phone;
        this.me.birthday = data.birthday;
        this.me.genderCode = data.genderCode;
        this.me.city = data.city;
        this.me.state = data.state;
        this.me.countryCode = data.countryCode;
        this.me.orgName = data.orgName;
        this.me.jobTitle = data.jobTitle;
        this.me.bio = data.bio;
        (0, _log.displayPopupMessage)('User information has been updated successfully', 'success');
        (0, _ga.writeGaEvent)(this, 'User', 'Update My Profile', email, '');
      }).catch(error => {
        (0, _log.showDebugLog)('Page-Profile-Save-Err', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    }
  }
};